export interface Command{}
export interface Query{}

export interface UserCommand extends Command {}

export interface UserQuery extends Query{}

export interface CommandWithFiles {
  body: object;
  files: Partial<Record<string, File>>;
}

export type Action<T extends Command | Query | void> = (payload: T) => Promise<void>;
export type UserAction<T extends UserCommand | UserQuery | void> = (payload: T) => Promise<void>;
export type UserActionWithFiles<T extends CommandWithFiles | void> = (payload: T) => Promise<void>;
export type UserActionWithTrialRun<T extends UserCommand | UserQuery | void>
  = (payload: { command: T, isTrialRun: boolean }) => Promise<void>;

export enum ActionStatus {
  None,
  InProgress,
  Successful,
  Failed,
}

// Stricter than InputValidationRule from vuetify/types
export type FormValidationRule<T> = (value: T) => boolean | string;

export interface FormField<T> {
  id?: string;
  value: T;
  rules?: FormValidationRule<T>[];
}

export interface OptionalValueFormField<T> {
  id?: string;
  value?: T;
  rules?: FormValidationRule<T>[];
}

export interface StrictFormDefinition {
  valid: boolean;
  fields?: {
    [key: string]: FormField<any> | OptionalValueFormField<any> | FormField<any>[];
  };
}

// Stand-in for Validatable from vuetify/lib/mixins/validatable
export interface VuetifyValidatable {
  validate(): () => boolean;
  resetValidation(): () => void;
}

// Structure expected by VSelect when not providing callbacks
export interface VuetifySelectItem<T> {
  text: string;
  value: T;
}
